<div class="diagram mt-5">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 575 559">
    <g id="Overall_Frame" data-name="Overall Frame" transform="translate(-421 -105)">
      <g
        id="Ellipse_35"
        data-name="Ellipse 35"
        transform="translate(785.26 262.281) rotate(91)"
        fill="#fff"
        stroke="#707070"
        stroke-width="2"
      >
        <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
        <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
      </g>
      <g
        id="Ellipse_34"
        data-name="Ellipse 34"
        transform="translate(782.225 264.229) rotate(91)"
        fill="#fff"
        stroke="#707070"
        stroke-width="2"
      >
        <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
        <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
      </g>
      <g
        id="Ellipse_33"
        data-name="Ellipse 33"
        transform="translate(778.156 268.158) rotate(91)"
        fill="#fff"
        stroke="#707070"
        stroke-width="2"
      >
        <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
        <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
      </g>
      <g
        id="Ellipse_32"
        data-name="Ellipse 32"
        transform="translate(774.104 271.088) rotate(91)"
        fill="#fff"
        stroke="#707070"
        stroke-width="2"
      >
        <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
        <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
      </g>
      <g id="Elements">
        <g id="Group_233" data-name="Group 233" transform="translate(5 -4)">
          <path
            id="Path_141"
            data-name="Path 141"
            d="M8465.693,1137.6l26.611-33.19h53.864l25.445,33.19v84.384l-21.325,39.087H8493.78l-28.087-39.087Z"
            transform="translate(-7797 -792)"
            fill="#ffe6b7"
            stroke="#707070"
            stroke-width="2"
          />
          <g
            id="Ellipse_39"
            data-name="Ellipse 39"
            transform="translate(672 263)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_38"
            data-name="Ellipse 38"
            transform="translate(674 266)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_37"
            data-name="Ellipse 37"
            transform="translate(678 270)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_36"
            data-name="Ellipse 36"
            transform="translate(681 274)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <path
            id="Path_142"
            data-name="Path 142"
            d="M8465.693,1141.491l29.731-37.081h60.18l28.428,37.081v94.277l-26.146,42.911H8498.5l-32.811-42.911Z"
            transform="translate(-7803.209 -800.539)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
          />
          <path
            id="Path_152"
            data-name="Path 152"
            d="M7224,1271.143h7.41v45.59H7224Z"
            transform="translate(2017.143 -6978.897) rotate(90)"
            fill="#e0fff3"
            stroke="#707070"
            stroke-width="2"
          />
          <path
            id="Path_153"
            data-name="Path 153"
            d="M7224,1271.143h7.41v45.59H7224Z"
            transform="translate(2017.143 -6978.897) rotate(90)"
            fill="#ffe6b7"
            stroke="#707070"
            stroke-width="2"
          />
          <path
            id="Path_147"
            data-name="Path 147"
            d="M7224,1271.143h7.41v45.59H7224Z"
            transform="translate(2019.143 -6689.897) rotate(90)"
            fill="#e0fff3"
            stroke="#707070"
            stroke-width="2"
          />
          <path
            id="Path_155"
            data-name="Path 155"
            d="M7224,1271.143h7.41v45.59H7224Z"
            transform="translate(2019.143 -6689.897) rotate(90)"
            fill="#ffe6b7"
            stroke="#707070"
            stroke-width="2"
          />
          <path
            id="Path_148"
            data-name="Path 148"
            d="M7225.99,1368.626h-20.27v40.638h20.27v-7.774h-12.555V1376.2h12.555Z"
            transform="translate(-6531 -835)"
            fill="#ffe6b7"
            stroke="#707070"
            stroke-width="2"
          />
          <path
            id="Path_149"
            data-name="Path 149"
            d="M7205.721,1368.626h25.4v40.638h-25.4v-7.774h15.733V1376.2h-15.733Z"
            transform="translate(-6449.73 -835)"
            fill="#ffe6b7"
            stroke="#707070"
            stroke-width="2"
          />
          <path
            id="Path_156"
            data-name="Path 156"
            d="M7224,1271.143h8.064v105.921H7224Z"
            transform="translate(2045.757 -6803.552) rotate(90)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          />
        </g>
      </g>

      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_strut_tower_apron'] || ''"
        [attr.data-name]="'frame.rht_strut_tower_apron' | translate"
      >
        <g
          class="parts"
          id="RHT_Strut_Tower_Apron-2"
          data-name="RHT Strut Tower Apron"
          transform="translate(771.543 271.088) rotate(91)"
          fill="#fff"
          stroke="#707070"
          stroke-width="2"
        >
          <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
          <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
        </g>
        <rect
          id="Rectangle_38"
          data-name="Rectangle 38"
          width="157"
          height="24"
          rx="12"
          transform="translate(832 214)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RHT_Strut_Tower_Apron-3"
          data-name="RHT Strut Tower Apron"
          transform="translate(861 230)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'frame.rht_strut_tower_apron' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 214)"
          fill="#f9b22a"
        />
        <text
          id="_3.0"
          data-name="3.0"
          transform="translate(838 229)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <g class="arrow" id="Arrow">
          <path
            id="Path_196"
            data-name="Path 196"
            d="M6133.164,1038.975l33.092-52h37.117"
            transform="translate(-5369.32 -761.975)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_195"
            data-name="Path 195"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(762 274)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_frt_rail'] || ''"
        [attr.data-name]="'frame.rht_frt_rail' | translate"
      >
        <path
          class="parts"
          id="RFT_FRT_Rail-2"
          data-name="RHT FRT Rail"
          d="M7224,1271.143h7.41v53.25H7224Z"
          transform="translate(-6473 -1030.143)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        />
        <rect
          id="Rectangle_38-2"
          data-name="Rectangle 38"
          width="121"
          height="24"
          rx="12"
          transform="translate(832 178)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RFT_FRT_Rail-3"
          data-name="RHT FRT Rail"
          transform="translate(861 194)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.rht_frt_rail' | translate }}</tspan>
        </text>
        <circle
          id="Ellipse_21-2"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 178)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-2"
          data-name="3.0"
          transform="translate(838 193)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <g class="arrow" id="Arrow-2" data-name="Arrow">
          <path
            id="Path_193"
            data-name="Path 193"
            d="M6133.527,1056.05,6180.79,973.1s14.889.027,20.911.006c.251,0,14.109,0,14.469-.006"
            transform="translate(-5379.052 -783.105)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_192"
            data-name="Path 192"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(752 269)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['cawl_panel_firewall'] || ''"
        [attr.data-name]="'frame.cawl_panel_firewall' | translate"
      >
        <path
          class="parts"
          id="Cawl_Panel_Firewall-2"
          data-name="Cawl Panel Firewall"
          d="M7224,1271.143h12.77v45.59H7224v-9.115l5-6.687V1287.3l-5-5.616Z"
          transform="translate(2022.143 -6936.897) rotate(90)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        />
        <rect
          id="Rectangle_38-3"
          data-name="Rectangle 38"
          width="140"
          height="24"
          rx="12"
          transform="translate(832 141)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="Cawl_Panel_Firewall-3"
          data-name="Cawl Panel Firewall"
          transform="translate(861 156)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'frame.cawl_panel_firewall' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-3" data-name="Arrow">
          <path
            id="Path_190"
            data-name="Path 190"
            d="M6133.527,1110.587,6168.766,973.1s58.444.054,61.467,0"
            transform="translate(-5398.232 -820.105)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_191"
            data-name="Path 191"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(732 288)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-3"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 141)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-3"
          data-name="3.0"
          transform="translate(838 156)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['radiator_support'] || ''"
        [attr.data-name]="'frame.radiator_support' | translate"
      >
        <path
          id="Path_186"
          data-name="Path 186"
          d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
          transform="translate(695.117 252)"
          fill="#333"
        />
        <path
          class="parts"
          id="Radiator_Support-2"
          data-name="Radiator Support"
          d="M7224,1271.143h7.41v45.59H7224Z"
          transform="translate(2022.143 -6995.897) rotate(90)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        />
        <rect
          id="Rectangle_38-4"
          data-name="Rectangle 38"
          width="131"
          height="24"
          rx="12"
          transform="translate(437 141)"
          fill="#242e3a"
          opacity="0.07"
        />
        <text
          id="Radiator_Support-3"
          data-name="Radiator Support"
          transform="translate(461 157)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.radiator_support' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-4" data-name="Arrow">
          <path
            id="Path_187"
            data-name="Path 187"
            d="M6276.294,1109.78l-37.07-70.482s-111.384.075-116.668,0"
            transform="translate(-5560 -886.298)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_189"
            data-name="Path 189"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(714.117 222)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-4"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 141)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-4"
          data-name="3.0"
          transform="translate(550 156)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_strut_tower_apron'] || ''"
        [attr.data-name]="'frame.lft_strut_tower_apron' | translate"
      >
        <g
          class="parts"
          id="LFT_Strut_Tower_Apron-2"
          data-name="LFT Strut Tower Apron"
          transform="translate(688 271)"
          fill="#fff"
          stroke="#707070"
          stroke-width="2"
        >
          <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
          <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
        </g>
        <rect
          id="Rectangle_38-5"
          data-name="Rectangle 38"
          width="147"
          height="24"
          rx="12"
          transform="translate(421 213)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="LFT_Strut_Tower_Apron-3"
          data-name="LFT Strut Tower Apron"
          transform="translate(438 229)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'frame.lft_strut_tower_apron' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-5" data-name="Arrow">
          <path
            id="Path_183"
            data-name="Path 183"
            d="M6289.117,1110.962l-24.413-47h-95.682"
            transform="translate(-5599 -837.962)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_184"
            data-name="Path 184"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(689.117 272)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-5"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 213)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-5"
          data-name="3.0"
          transform="translate(550 228)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_frt_rail'] || ''"
        [attr.data-name]="'frame.lft_frt_rail' | translate"
      >
        <path
          class="parts"
          id="LFT_FRT_Rail-2"
          data-name="LFT FRT Rail"
          d="M7224,1271.143h7.41v53.25H7224Z"
          transform="translate(-6526 -1030.143)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        />
        <rect
          id="Rectangle_38-6"
          data-name="Rectangle 38"
          width="112"
          height="24"
          rx="12"
          transform="translate(456 177)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="LFT_FRT_Rail-3"
          data-name="LFT FRT Rail"
          transform="translate(481 193)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.lft_frt_rail' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-6" data-name="Arrow">
          <path
            id="Path_185"
            data-name="Path 185"
            d="M6272.05,1106.9l-34.361-67.6s-85.27.084-90.508,0"
            transform="translate(-5576 -851.057)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_188"
            data-name="Path 188"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(695.117 254)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-6"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 177)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-6"
          data-name="3.0"
          transform="translate(550 192)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_apron'] || ''"
        [attr.data-name]="'frame.lft_apron' | translate"
      >
        <path
          class="parts"
          id="LFT_Apron-2"
          data-name="LFT Apron"
          d="M7197.023,1253.1h8.417v19.135h-8.417Z"
          transform="translate(-6502 -975)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-7"
          data-name="Rectangle 38"
          width="107"
          height="24"
          rx="12"
          transform="translate(461 295)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="LFT_Apron-3"
          data-name="LFT Apron"
          transform="translate(491 311)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.lft_apron' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-7" data-name="Arrow">
          <path
            id="Path_181"
            data-name="Path 181"
            d="M6276.977,1050.978l-44.126,14.26H6157"
            transform="translate(-5589 -758.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_182"
            data-name="Path 182"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(692 290)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-7"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 295)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-7"
          data-name="3.0"
          transform="translate(550 310)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rft_apron'] || ''"
        [attr.data-name]="'frame.rht_apron' | translate"
      >
        <path
          class="parts"
          id="RFT_Apron-2"
          data-name="RFT Apron"
          d="M7197.023,1253.1h8.417v19.135h-8.417Z"
          transform="translate(-6447 -975)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-8"
          data-name="Rectangle 38"
          width="117"
          height="24"
          rx="12"
          transform="translate(831 302)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RFT_Apron-3"
          data-name="RFT Apron"
          transform="translate(861 318)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.rht_apron' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-8" data-name="Arrow">
          <path
            id="Path_198"
            data-name="Path 198"
            d="M6133.527,1024.1l35.975,24.5s37.022.036,41.183,0"
            transform="translate(-5375.232 -731.623)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_197"
            data-name="Path 197"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(755 289)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-8"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(831 302)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-8"
          data-name="3.0"
          transform="translate(837 317)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_a_pillar'] || ''"
        [attr.data-name]="'frame.lft_a_pillar' | translate"
      >
        <path
          class="parts"
          id="LFT_A-Pillar-2"
          data-name="LFT A-Pillar"
          d="M7197.023,1253.1h8.417v19.135h-8.417Z"
          transform="translate(-6532 -917)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-9"
          data-name="Rectangle 38"
          width="107"
          height="24"
          rx="12"
          transform="translate(461 331)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="LFT_A-Pillar-3"
          data-name="LFT A-Pillar"
          transform="translate(485 347)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.lft_a_pillar' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-9" data-name="Arrow">
          <path
            id="Path_177"
            data-name="Path 177"
            d="M6241.776,1065.238H6157"
            transform="translate(-5586 -722.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_178"
            data-name="Path 178"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(657.117 340)"
            fill="#8e9093"
          />
        </g>
        <circle
          id="Ellipse_21-9"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 331)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-9"
          data-name="3.0"
          transform="translate(550 346)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rft_a_pillar'] || ''"
        [attr.data-name]="'frame.rht_a_pillar' | translate"
      >
        <path
          class="parts"
          id="RFT_A-Pillar-2"
          data-name="RFT A-Pillar"
          d="M7197.023,1253.1h8.417v19.135h-8.417Z"
          transform="translate(-6416 -917)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-10"
          data-name="Rectangle 38"
          width="117"
          height="24"
          rx="12"
          transform="translate(832 334)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RFT_A-Pillar-3"
          data-name="RFT A-Pillar"
          transform="translate(861 350)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.rht_a_pillar' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-10" data-name="Arrow">
          <path
            id="Path_202"
            data-name="Path 202"
            d="M6190.293,1065.238H6157"
            transform="translate(-5362.883 -719.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_203"
            data-name="Path 203"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(791.117 343)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-10"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 334)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-10"
          data-name="3.0"
          transform="translate(838 349)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_b_pillar'] || ''"
        [attr.data-name]="'frame.lft_b_pillar' | translate"
      >
        <path
          class="parts"
          id="LFT_B-Pillar-2"
          data-name="LFT B-Pillar"
          d="M7197.023,1253.1h8.417v19.135h-8.417Z"
          transform="translate(-6532 -883.095)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-11"
          data-name="Rectangle 38"
          width="107"
          height="24"
          rx="12"
          transform="translate(461 367)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="LFT_B-Pillar-3"
          data-name="LFT B-Pillar"
          transform="translate(485 383)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.lft_b_pillar' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-11" data-name="Arrow">
          <path
            id="Path_174"
            data-name="Path 174"
            d="M6241.776,1065.238H6157"
            transform="translate(-5586 -685.739)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_175"
            data-name="Path 175"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(657.117 376)"
            fill="#8e9093"
          />
        </g>
        <circle
          id="Ellipse_21-11"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 367)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-11"
          data-name="3.0"
          transform="translate(550 382)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rft_b_pillar'] || ''"
        [attr.data-name]="'frame.rht_b_pillar' | translate"
      >
        <path
          class="parts"
          id="RFT_B-Pillar-2"
          data-name="RFT B-Pillar"
          d="M7197.023,1253.1h8.417v19.135h-8.417Z"
          transform="translate(-6416 -883.095)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-12"
          data-name="Rectangle 38"
          width="117"
          height="24"
          rx="12"
          transform="translate(832 370)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RFT_B-Pillar-3"
          data-name="RFT B-Pillar"
          transform="translate(861 386)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.rht_b_pillar' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-12" data-name="Arrow">
          <path
            id="Path_205"
            data-name="Path 205"
            d="M6190.293,1065.238H6157"
            transform="translate(-5362.883 -683.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_204"
            data-name="Path 204"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(791.117 379)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-12"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 370)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-12"
          data-name="3.0"
          transform="translate(838 385)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_c_pillar'] || ''"
        [attr.data-name]="'frame.left_c_pillar' | translate"
      >
        <path
          class="parts"
          id="Left_C-Pillar-2"
          data-name="Left C-Pillar"
          d="M7197.023,1253.1h8.417v19.135h-8.417Z"
          transform="translate(-6532 -840.095)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-13"
          data-name="Rectangle 38"
          width="107"
          height="24"
          rx="12"
          transform="translate(461 411)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="Left_C-Pillar-3"
          data-name="Left C-Pillar"
          transform="translate(484 427)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.left_c_pillar' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-13" data-name="Arrow">
          <path
            id="Path_172"
            data-name="Path 172"
            d="M6241.776,1065.238H6157"
            transform="translate(-5586 -642.739)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_173"
            data-name="Path 173"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(657.117 420)"
            fill="#8e9093"
          />
        </g>
        <circle
          id="Ellipse_21-13"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 411)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-13"
          data-name="3.0"
          transform="translate(550 426)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rft_c_pillar'] || ''"
        [attr.data-name]="'frame.rht_c_pillar' | translate"
      >
        <path
          class="parts"
          id="RFT_C-Pillar-2"
          data-name="RFT C-Pillar"
          d="M7197.023,1253.1h8.417v19.135h-8.417Z"
          transform="translate(-6416 -840.095)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-14"
          data-name="Rectangle 38"
          width="117"
          height="24"
          rx="12"
          transform="translate(832 406)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RFT_C-Pillar-3"
          data-name="RFT C-Pillar"
          transform="translate(861 422)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.rht_c_pillar' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-14" data-name="Arrow">
          <path
            id="Path_207"
            data-name="Path 207"
            d="M6190.293,1065.238H6157"
            transform="translate(-5362.883 -645.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_206"
            data-name="Path 206"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(791.117 417)"
            fill="#696969"
          />
        </g>
        <circle
          id="Ellipse_21-14"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 406)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-14"
          data-name="3.0"
          transform="translate(838 421)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['suspensions'] || ''"
        [attr.data-name]="'frame.suspension' | translate"
      >
        <g class="parts" id="Suspension-2" data-name="Suspension">
          <g
            id="Ellipse_28"
            data-name="Ellipse 28"
            transform="translate(785.26 474.281) rotate(91)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_29"
            data-name="Ellipse 29"
            transform="translate(782.225 476.229) rotate(91)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_30"
            data-name="Ellipse 30"
            transform="translate(778.156 480.158) rotate(91)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_31"
            data-name="Ellipse 31"
            transform="translate(774.104 483.088) rotate(91)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_24"
            data-name="Ellipse 24"
            transform="translate(677 471)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_25"
            data-name="Ellipse 25"
            transform="translate(679 474)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_26"
            data-name="Ellipse 26"
            transform="translate(683 478)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
          <g
            id="Ellipse_27"
            data-name="Ellipse 27"
            transform="translate(686 482)"
            fill="#fff"
            stroke="#707070"
            stroke-width="2"
          >
            <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
            <circle cx="10.5" cy="10.5" r="9.5" fill="none" />
          </g>
        </g>
        <rect
          id="Rectangle_38-15"
          data-name="Rectangle 38"
          width="108"
          height="24"
          rx="12"
          transform="translate(460 476)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="Suspension-3"
          data-name="Suspension"
          transform="translate(485 491)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.suspension' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-15" data-name="Arrow">
          <path
            id="Path_169"
            data-name="Path 169"
            d="M6257.659,1065.238H6157"
            transform="translate(-5586 -577.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_171"
            data-name="Path 171"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(673 485)"
            fill="#8e9093"
          />
        </g>
        <circle
          id="Ellipse_21-15"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 476)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-15"
          data-name="3.0"
          transform="translate(550 491)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_rr_rail'] || ''"
        [attr.data-name]="'frame.rht_rr_rail' | translate"
      >
        <path
          class="parts"
          id="RFT_RR_Rail-2"
          data-name="RHT RR Rail"
          d="M7224,1271.143h7.41v99.107H7224Z"
          transform="translate(-6471 -796)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        />
        <rect
          id="Rectangle_38-16"
          data-name="Rectangle 38"
          width="131"
          height="24"
          rx="12"
          transform="translate(831 508)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RFT_RR_Rail-3"
          data-name="RHT RR Rail"
          transform="translate(861 524)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.rht_rr_rail' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-16" data-name="Arrow">
          <path
            id="Path_208"
            data-name="Path 208"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(754 517)"
            fill="#8e9093"
          />
          <path
            id="Path_209"
            data-name="Path 209"
            d="M6224.293,1065.238H6157"
            transform="translate(-5397.883 -545.238)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
        <circle
          id="Ellipse_21-16"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(831 508)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-16"
          data-name="3.0"
          transform="translate(837 523)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rr_rail'] || ''"
        [attr.data-name]="'frame.lft_rr_rail' | translate"
      >
        <path
          class="parts"
          id="LFT_RR_Rail-2"
          data-name="LFT RR Rail"
          d="M7224,1271.143h7.41v99.107H7224Z"
          transform="translate(-6524 -796)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        />
        <rect
          id="Rectangle_38-17"
          data-name="Rectangle 38"
          width="116"
          height="24"
          rx="12"
          transform="translate(452 532)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="LFT_RR_Rail-3"
          data-name="LFT RR Rail"
          transform="translate(486 548)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.lft_rr_rail' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-17" data-name="Arrow">
          <path
            id="Path_167"
            data-name="Path 167"
            d="M6284,1050.978l-46.709,15.08H6157"
            transform="translate(-5586 -521.975)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_168"
            data-name="Path 168"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(695 527)"
            fill="#8e9093"
          />
        </g>
        <circle
          id="Ellipse_21-17"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 532)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-17"
          data-name="3.0"
          transform="translate(550 547)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_rr_d_pillar'] || ''"
        [attr.data-name]="'frame.rht_rr_d_pillar' | translate"
      >
        <path
          class="parts"
          id="RFT_D-Pillar-2"
          data-name="RFT RR D-Pillar"
          d="M7223.654,1402.4h-8.8v5.177h-5.77V1415h14.575Z"
          transform="translate(-6435.527 -843)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-18"
          data-name="Rectangle 38"
          width="131"
          height="24"
          rx="12"
          transform="translate(832 544)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RFT_D-Pillar-3"
          data-name="RFT RR D-Pillar"
          transform="translate(861 560)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">RFT RR D-Pillar</tspan>
        </text>
        <circle
          id="Ellipse_21-18"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(831 544)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-18"
          data-name="3.0"
          transform="translate(837 559)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <g class="arrow" id="Arrow-18" data-name="Arrow">
          <path
            id="Path_212"
            data-name="Path 212"
            d="M6193.969,1056.475l-10.457,8.763H6157"
            transform="translate(-5365.614 -500.238)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_249"
            data-name="Ellipse 249"
            cx="3"
            cy="3"
            r="3"
            transform="translate(788 562)"
            fill="#8e9093"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rr_d_pillar'] || ''"
        [attr.data-name]="'frame.lft_rr_d_pillar' | translate"
      >
        <path
          class="parts"
          id="LFT_RR_D-Pillar-2"
          data-name="LFT RR D-Pillar"
          d="M7209.08,1402.4h9.952v5.177h6.521V1415H7209.08Z"
          transform="translate(-6532 -843)"
          fill="#8e9093"
        />
        <rect
          id="Rectangle_38-19"
          data-name="Rectangle 38"
          width="131"
          height="24"
          rx="12"
          transform="translate(437 568)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="LFT_RR_D-Pillar-3"
          data-name="LFT RR D-Pillar"
          transform="translate(470 584)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.lft_rr_d_pillar' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-19" data-name="Arrow">
          <path
            id="Path_165"
            data-name="Path 165"
            d="M6257.659,1055.534l-39.73,10.082H6157"
            transform="translate(-5586 -485.534)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_166"
            data-name="Path 166"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(669 567)"
            fill="#8e9093"
          />
        </g>
        <circle
          id="Ellipse_21-19"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 568)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-19"
          data-name="3.0"
          transform="translate(550 583)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['lft_rr_lock_pillar'] || ''"
        [attr.data-name]="'frame.lft_rr_lock_pillar' | translate"
      >
        <path
          class="parts"
          id="LFT_RR_Lock_Pillar-2"
          data-name="LFT RR Lock Pillar"
          d="M8456.836,1394.23h18.191v-9.553H8468v-4.914h-11.16Z"
          transform="translate(-7775 -802)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        />
        <rect
          id="Rectangle_38-20"
          data-name="Rectangle 38"
          width="143"
          height="24"
          rx="12"
          transform="translate(425 604)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="LFT_RR_Lock_Pillar-3"
          data-name="LFT RR Lock Pillar"
          transform="translate(456 620)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'frame.lft_rr_lock_pillar' | translate }}
          </tspan>
        </text>
        <g class="arrow" id="Arrow-20" data-name="Arrow">
          <path
            id="Path_162"
            data-name="Path 162"
            d="M6280,1047.652l-15.354,21.082H6157"
            transform="translate(-5589 -452.652)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_163"
            data-name="Path 163"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(688 592)"
            fill="#8e9093"
          />
        </g>
        <circle
          id="Ellipse_21-20"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 604)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-20"
          data-name="3.0"
          transform="translate(550 619)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rht_rr_lock_pillar'] || ''"
        [attr.data-name]="'frame.rht_rr_lock_pillar' | translate"
      >
        <path
          class="parts"
          id="RFT_RR_Lock_Pillar-2"
          data-name="RHT RR Lock Pillar"
          d="M8474.654,1394.23h-17.819v-9.553h6.888v-4.914h10.932Z"
          transform="translate(-7687.809 -802)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        />
        <g class="arrow" id="Arrow-21" data-name="Arrow">
          <path
            id="Path_213"
            data-name="Path 213"
            d="M6159.422,1008.936l10.371,20.512h31.08"
            transform="translate(-5378.883 -412.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_214"
            data-name="Path 214"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(778 594)"
            fill="#8e9093"
          />
        </g>
        <rect
          id="Rectangle_38-21"
          data-name="Rectangle 38"
          width="146"
          height="24"
          rx="12"
          transform="translate(832 604)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RFT_RR_Lock_Pillar-3"
          data-name="RHT RR Lock Pillar"
          transform="translate(861 620)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'frame.rht_rr_lock_pillar' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-21"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 604)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-21"
          data-name="3.0"
          transform="translate(838 619)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['perimeter_frame'] || ''"
        [attr.data-name]="'frame.perimeter_frame' | translate"
      >
        <path
          class="parts"
          id="Perimeter_Frame-2"
          data-name="Perimeter Frame"
          d="M7224,1271.143h7.41v45.59H7224Z"
          transform="translate(2024.143 -6656.897) rotate(90)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        />
        <rect
          id="Rectangle_38-22"
          data-name="Rectangle 38"
          width="131"
          height="24"
          rx="12"
          transform="translate(437 640)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="Perimeter_Frame-3"
          data-name="Perimeter Frame"
          transform="translate(462 656)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.perimeter_frame' | translate }}</tspan>
        </text>
        <g class="arrow" id="Arrow-22" data-name="Arrow">
          <path
            id="Path_161"
            data-name="Path 161"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(730 573)"
            fill="#8e9093"
          />
          <path
            id="Path_160"
            data-name="Path 160"
            d="M6322.105,991.773l-60.912,73.465H6157"
            transform="translate(-5589 -413.156)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
        <circle
          id="Ellipse_21-22"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 640)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-22"
          data-name="3.0"
          transform="translate(550 655)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['floor_pans'] || ''"
        [attr.data-name]="'frame.floor_pans' | translate"
      >
        <rect
          id="Rectangle_38-23"
          data-name="Rectangle 38"
          width="99"
          height="24"
          rx="12"
          transform="translate(832 640)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="Floor_Pans-2"
          data-name="Floor Pans"
          transform="translate(861 656)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.floor_pans' | translate }}</tspan>
        </text>
        <circle
          id="Ellipse_21-23"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 640)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-23"
          data-name="3.0"
          transform="translate(838 655)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['frt_cross_member'] || ''"
        [attr.data-name]="'frame.frt_cross_member' | translate"
      >
        <g
          class="parts"
          id="FRT_Cross_Member-2"
          data-name="FRT Cross Member"
          transform="translate(717 256)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        >
          <rect width="22" height="22" stroke="none" />
          <rect x="1" y="1" width="20" height="20" fill="none" />
        </g>
        <rect
          id="Rectangle_38-24"
          data-name="Rectangle 38"
          width="140"
          height="24"
          rx="12"
          transform="translate(832 105)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="FRT_Cross_Member-3"
          data-name="FRT Cross Member"
          transform="translate(861 120)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.frt_cross_member' | translate }}</tspan>
        </text>
        <circle
          id="Ellipse_21-24"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 105)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-24"
          data-name="3.0"
          transform="translate(838 120)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <g class="arrow" id="Arrow-23" data-name="Arrow">
          <path
            id="Path_523"
            data-name="Path 523"
            d="M6133.527,1121.586,6170.952,973.1s62.071.059,65.281,0"
            transform="translate(-5405.232 -856.105)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <circle
            id="Ellipse_247"
            data-name="Ellipse 247"
            cx="3"
            cy="3"
            r="3"
            transform="translate(726 260)"
            fill="#696969"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['gear_foundation'] || ''"
        [attr.data-name]="'frame.gear_foundation' | translate"
      >
        <g
          class="parts"
          id="Gear_Foundation-2"
          data-name="Gear Foundation"
          transform="translate(724 279)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        >
          <rect width="8" height="8" stroke="none" />
          <rect x="1" y="1" width="6" height="6" fill="none" />
        </g>
        <g class="arrow" id="Arrow-24" data-name="Arrow">
          <path
            id="Path_527"
            data-name="Path 527"
            d="M9476.117,2059h107.2"
            transform="translate(-8751 -1776)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
          <path
            id="Path_526"
            data-name="Path 526"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(722.117 280)"
            fill="#696969"
          />
        </g>
        <rect
          id="Rectangle_38-25"
          data-name="Rectangle 38"
          width="127"
          height="24"
          rx="12"
          transform="translate(829 271)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="Gear_Foundation-3"
          data-name="Gear Foundation"
          transform="translate(861 287)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.gear_foundation' | translate }}</tspan>
        </text>
        <circle
          id="Ellipse_21-25"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(829 271)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-25"
          data-name="3.0"
          transform="translate(835 286)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['rr_cross_member'] || ''"
        [attr.data-name]="'frame.rht_rr_cross_member' | translate"
      >
        <g
          class="parts"
          id="RFT_RR_Cross_Member-2"
          data-name="RFT RR Cross Member"
          transform="translate(717 540)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        >
          <rect width="22" height="22" stroke="none" />
          <rect x="1" y="1" width="20" height="20" fill="none" />
        </g>
        <rect
          id="Rectangle_38-26"
          data-name="Rectangle 38"
          width="164"
          height="24"
          rx="12"
          transform="translate(832 454)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="RFT_RR_Cross_Member-3"
          data-name="RFT RR Cross Member"
          transform="translate(861 470)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">
            {{ 'frame.rht_rr_cross_member' | translate }}
          </tspan>
        </text>
        <circle
          id="Ellipse_21-26"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(832 454)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-26"
          data-name="3.0"
          transform="translate(838 469)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <g class="arrow" id="Arrow-25" data-name="Arrow">
          <path
            id="Path_528"
            data-name="Path 528"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(724 545)"
            fill="#8e9093"
          />
          <path
            id="Path_529"
            data-name="Path 529"
            d="M9477.938,2324v-38.847l102.766-40.39"
            transform="translate(-8751 -1776)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
      </g>
      <g
        (click)="openCondition($event)"
        class="partGrp {{ !vinInfo?.['is_salvage'] ? 'excellent' : 'junk' }}"
        [id]="parts['engine_foundation'] || ''"
        [attr.data-name]="'frame.engine_foundation' | translate"
      >
        <rect
          id="Rectangle_38-27"
          data-name="Rectangle 38"
          width="141"
          height="24"
          rx="12"
          transform="translate(427 249)"
          fill="#242e3a"
          opacity="0.075"
        />
        <text
          id="Engine_Foundation-2"
          data-name="Engine Foundation"
          transform="translate(454 264)"
          fill="#242e3a"
          font-size="10"
          font-family="Roboto-Medium, Roboto"
          font-weight="500"
        >
          <tspan x="0" y="0">{{ 'frame.engine_foundation' | translate }}</tspan>
        </text>
        <circle
          id="Ellipse_21-27"
          data-name="Ellipse 21"
          cx="12"
          cy="12"
          r="12"
          transform="translate(544 249)"
          fill="#f9b22a"
        />
        <text
          id="_3.0-27"
          data-name="3.0"
          transform="translate(550 264)"
          font-size="8"
          font-family="Roboto-Bold, Roboto"
          font-weight="700"
        >
          <tspan x="0" y="0" class="score">{{ defaultRating }}</tspan>
        </text>
        <g
          class="parts"
          id="Engine_Foundation-3"
          data-name="Engine Foundation"
          transform="translate(724 270)"
          fill="#ffe6b7"
          stroke="#707070"
          stroke-width="2"
        >
          <rect width="8" height="8" stroke="none" />
          <rect x="1" y="1" width="6" height="6" fill="none" />
        </g>
        <g class="arrow" id="Arrow-26" data-name="Arrow">
          <path
            id="Path_525"
            data-name="Path 525"
            d="M3,0A3,3,0,1,1,0,3,3,3,0,0,1,3,0Z"
            transform="translate(719.117 271)"
            fill="#696969"
          />
          <path
            id="Path_524"
            data-name="Path 524"
            d="M9470.117,2049.958l-61.188,7.9-89.991-19.289"
            transform="translate(-8751 -1776)"
            fill="none"
            stroke="#707070"
            stroke-width="2"
            stroke-dasharray="2"
          />
        </g>
      </g>
    </g>
  </svg>

  <loader [position]="{ absolute: true }" [active]="loaded"></loader>
</div>

<div
  class="container mt-4"
  style="display: flex; align-items: center; justify-content: center; gap: 1rem"
>
  <div class="alert alert-success d-inline-block py-1 px-3">
    <strong>&quot;*&quot;</strong> : QC Passed
  </div>
  <div class="alert alert-danger d-inline-block py-1 px-3">
    <strong>&quot;-&quot;</strong> : QC Failed
  </div>
</div>

<!-- Modal -->
<ng-template #condition>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ modalTitle }}</h4>

    <div>
      <app-rating-activity
        [vehicleId]="vehicleId"
        [parentPartId]="partId"
        (logDetails)="receiveData($event)"
      ></app-rating-activity>
    </div>

    <button type="button" class="close" (click)="modalRef.hide()">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </div>
  <form
    class="condition__form credential"
    [formGroup]="conditionForm"
    (submit)="saveConditionState()"
  >
    <div class="modal-body conditionModal__body">
      <div class="vam_show_car_form_container">
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.condition' | translate
              }}</label>
              <ng-container *ngIf="lang == 'en'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                >
                </ng-select>
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                <ng-select
                  name="parts_conditions_id"
                  formControlName="parts_conditions_id"
                  class="credential__multiSelect form-group"
                  [class.is-invalid]="formData.parts_conditions_id.invalid && this.submitted"
                  [items]="partCondition"
                  [multiple]="true"
                  [closeOnSelect]="true"
                  [searchable]="true"
                  bindLabel="parts_condition_name_arabic"
                  bindValue="parts_condition_id"
                  placeholder="Select condition"
                >
                </ng-select>
              </ng-container>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.severity' | translate
              }}</label>
              <select
                class="form-control credential__select-lg"
                formControlName="vpcs_severity"
                [class.is-invalid]="formData.vpcs_severity.invalid && this.submitted"
                [attr.disabled]="role === 'estimator' || role === 'purchasemanager' ? '' : null"
              >
                <option value="" disabled="true" selected="true">Select Severity</option>
                <option [value]="1">1 (Part Change Needed)</option>
                <option [value]="2">2 (Major Repair Needed)</option>
                <option [value]="3">3 (Moderate Repair needed)</option>
                <option [value]="4">4 (Minor Repair Needed)</option>
                <option [value]="5">5 (Good Part)</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="container mt-4 p-0">
            <form
              *ngIf="['qc', 'admin'].includes(role) && qcOptions.length && qcConditions.length"
              [formGroup]="qcForm"
              class="border p-3"
            >
              <div class="mb-4">
                <button
                  type="button"
                  class="btn qc-toggle-btn"
                  [class.qc-toggle-active]="toggle"
                  (click)="this.toggle = !this.toggle"
                  aria-pressed="false"
                  autocomplete="off"
                >
                  <span class="qc-toggle-label-on">Pass</span>
                  <span class="qc-toggle-label-off">Fail</span>
                  <div class="qc-toggle-handle"></div>
                </button>
              </div>
              <div
                class="d-flex form-group"
                *ngFor="let qcCondition of qcConditions; let i = index"
                [ngClass]="{ 'mt-3': i > 0 }"
              >
                <label [for]="qcCondition?.['condition_id']" class="col-form-label">
                  {{ qcCondition?.['parts_condition_name_' + lang] }}:
                </label>

                <div class="ml-3 flex-grow-1">
                  <select
                    class="form-control"
                    [id]="qcCondition?.['condition_id']"
                    [formControlName]="qcCondition?.['condition_id']"
                    [class.is-invalid]="hasError(qcCondition?.['condition_id'])"
                  >
                    <option value="">-- Please select --</option>
                    <option
                      *ngFor="let qcOption of qcOptions"
                      [value]="qcOption?.['review_status_id']"
                    >
                      {{ qcOption?.['name_' + lang] }}
                    </option>
                  </select>
                  <div *ngIf="hasError(qcCondition?.['condition_id'])" class="invalid-feedback">
                    {{ getErrorMessage(qcCondition?.['condition_id']) }}
                  </div>
                </div>
              </div>
              <div class="mt-3 p-2 bg-light rounded" *ngIf="qcForm">
                <small>
                  <strong>Work status:</strong>
                  <span [ngClass]="toggle ? 'text-success' : 'text-danger'">
                    {{ toggle ? 'Passed' : 'Failed' }}
                  </span>
                </small>
              </div>
            </form>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.description' | translate
              }}</label>
              <!-- <label class="modal_car_input_label">Description</label> -->
              <textarea
                class="form-control credential__textarea"
                formControlName="vpcs_s_dec"
                [class.is-invalid]="formData.vpcs_s_dec.invalid && this.submitted"
                [readonly]="role === 'evaluator' || role === 'purchasemanager'"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.labour_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_lb_cost"
                formControlName="vpcs_lb_cost"
                [class.is-invalid]="formData.vpcs_lb_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #labourCost
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.parts_cost' | translate
              }}</label>
              <input
                type="text"
                class="form-control credential__input-lg"
                name="vpcs_prt_cost"
                formControlName="vpcs_prt_cost"
                [class.is-invalid]="formData.vpcs_prt_cost.invalid && this.submitted"
                mask="separator.5"
                thousandSeparator=""
                [readonly]="role !== 'admin'"
                #partsCost
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="form-group">
              <label class="modal_car_input_label">{{
                'condition_modal.cost_of_repair' | translate
              }}</label>
              <input
                type="text"
                name="vpcs_rp_cost"
                formControlName="vpcs_rp_cost"
                class="form-control credential__input-lg"
                [class.is-invalid]="formData.vpcs_rp_cost.invalid && this.submitted"
                [value]="+labourCost.value + +partsCost.value || ''"
                readonly
              />
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.before' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image1"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image1"
                  formControlName="vpcs_old_image1"
                  class="form-conrol d-none"
                  id="vpcs_old_image1"
                  (change)="getFile($event, 'old', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld1'] || imageOld['beforeImg1']"
                />
                <img
                  [src]="imageOld['beforeImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg1'] && !filesOld['fileOld1']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld1'] && !imageOld['beforeImg1']">
                  {{ filesOld['fileOld1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld1'] || imageOld['beforeImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg1']"
                  (click)="openViewer(imageOld['beforeImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="!vehicleStatus || editableRole.includes(role)"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld1'] || imageOld['beforeImg1'], 'old', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
            >
              <label
                for="vpcs_old_image2"
                class="credential__file"
                [class.untouchable]="role === 'estimator' || role === 'purchasemanager'"
              >
                <input
                  type="file"
                  name="vpcs_old_image2"
                  formControlName="vpcs_old_image2"
                  class="form-conrol d-none"
                  id="vpcs_old_image2"
                  (change)="getFile($event, 'old', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesOld['fileOld2'] || imageOld['beforeImg2']"
                />
                <img
                  [src]="imageOld['beforeImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageOld['beforeImg2'] && !filesOld['fileOld2']"
                />
                <p class="fs fs__md" *ngIf="filesOld['fileOld2'] && !imageOld['beforeImg2']">
                  {{ filesOld['fileOld2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesOld['fileOld2'] || imageOld['beforeImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageOld['beforeImg2']"
                  (click)="openViewer(imageOld['beforeImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  *ngIf="!vehicleStatus || editableRole.includes(role)"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="role === 'estimator' || role === 'purchasemanager'"
                  [class.cursor-not-allowed]="role === 'estimator' || role === 'purchasemanager'"
                  (click)="removeImage(filesOld['fileOld2'] || imageOld['beforeImg2'], 'old', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-n2">
          <div class="col-12 px-2">
            <label for="" class="credential__label">{{
              'condition_modal.after' | translate
            }}</label>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image1"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image1"
                  formControlName="vpcs_new_image1"
                  class="form-conrol d-none"
                  id="vpcs_new_image1"
                  (change)="getFile($event, 'new', 1)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew1'] || imageNew['afterImg1']"
                />
                <img
                  [src]="imageNew['afterImg1']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg1'] && !filesNew['fileNew1']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew1'] && !imageNew['afterImg1']">
                  {{ filesNew['fileNew1'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew1'] || imageNew['afterImg1']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg1']"
                  (click)="openViewer(imageNew['afterImg1'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew1'] || imageNew['afterImg1'], 'new', 1)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-6 px-2">
            <div
              class="form-group position-relative"
              [class.cursor-not-allowed]="
                role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
              "
            >
              <label
                for="vpcs_new_image2"
                class="credential__file"
                [class.untouchable]="
                  role === 'estimator' || role === 'purchasemanager' || role === 'evaluator'
                "
              >
                <input
                  type="file"
                  name="vpcs_new_image2"
                  formControlName="vpcs_new_image2"
                  class="form-conrol d-none"
                  id="vpcs_new_image2"
                  (change)="getFile($event, 'new', 2)"
                />
                <img
                  src="assets/images/car-image_icon.svg"
                  [hidden]="filesNew['fileNew2'] || imageNew['afterImg2']"
                />
                <img
                  [src]="imageNew['afterImg2']"
                  class="conditionFormFilePreview"
                  *ngIf="imageNew['afterImg2'] && !filesNew['fileNew2']"
                />
                <p class="fs fs__md" *ngIf="filesNew['fileNew2'] && !imageNew['afterImg2']">
                  {{ filesNew['fileNew2'].name }}
                </p>
              </label>

              <div class="upload-actions" *ngIf="filesNew['fileNew2'] || imageNew['afterImg2']">
                <button
                  type="button"
                  class="btn btn__utils bg-ashen"
                  *ngIf="imageNew['afterImg2']"
                  (click)="openViewer(imageNew['afterImg2'])"
                >
                  <ion-icon name="eye-outline" class="ion-lg"></ion-icon>
                </button>
                <button
                  type="button"
                  class="btn btn__utils bg-cherry ml-auto"
                  [disabled]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  [class.cursor-not-allowed]="
                    role === 'estimator' ||
                    role === 'purchasemanager' ||
                    role === 'evaluator' ||
                    role === 'qc'
                  "
                  (click)="removeImage(filesNew['fileNew2'] || imageNew['afterImg2'], 'new', 2)"
                >
                  <ion-icon name="close-outline" class="ion-lg"></ion-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <loader [position]="{ absolute: true }" [active]="partConditionLoaded"></loader>
    </div>

    <div class="modal-footer conditionModal__footer">
      <div class="conditionModal__footerInner">
        <div
          class="row w-100 mx-0"
          *ngIf="!vehicleStatus || editableRole.includes(role) || role === 'qc'"
        >
          <div class="col-md-6 px-0 px-md-2 mb-3 mb-md-0">
            <button
              type="submit"
              class="btn btn__primary w-100"
              [disabled]="partConditionLoaded || conditionSubmitting || role === 'purchasemanager'"
            >
              {{ 'condition_modal.save' | translate }}
              <span
                class="spinner-grow spinner-grow-sm text-light ml-2"
                [hidden]="!conditionSubmitting"
              >
              </span>
            </button>
          </div>
          <div class="col-md-6 px-0 px-md-2">
            <button
              type="button"
              class="btn btn__secondary w-100"
              [disabled]="partConditionLoaded"
              (click)="modalRef.hide(); conditionForm.reset()"
            >
              {{ 'condition_modal.set_default' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>
